import React, { Component, Fragment } from "react";
import { CRUDFunction } from "../../../reduxCURD/container";
import { curdActions } from "../../../reduxCURD/actions";
import { getAppMockupsTypes } from "../../../reduxRelated/actions/diagnosticsActions";
import ConfirmationDialog from "components/Common/ConfirmationDialog";
import {
  onMaintenanceReceive,
  onExecutionInspectionReceive,
  onLineSelfLoad,
  handleMaintenanceLocationClick,
  onMaterialTypesReceive,
} from "./HelperMethods/MaintenanceDetailHelper";
import { MaintenanceDetailHeaderView } from "./DetailViews/MaintennaceDetailHeaderView";
import { languageService } from "../../../Language/language.service";
import { M_DetailContainer } from "./DetailViews/DetailContainer";
import { JourneyPlanHelper } from "../../../utils/journeyPlanHelper";
import { getAssetLinesWithSelf } from "../../../reduxRelated/actions/assetHelperAction";
import { maintenaceDetailstyle } from "../styles/maintenanceDetailstyle";
import { themeService } from "../../../theme/service/activeTheme.service";
import Gravatar from "react-gravatar";
import SvgIcon from "react-icons-kit";
import { ic_gps_fixed } from "react-icons-kit/md/ic_gps_fixed";
import { substractObjects } from "../../../utils/utils";
import ReportMrModel from "./DetailViews/DetailViewModels/ReportModel.jsx/ReportMRModel";
import { ExtendedMaterialUsageCSVMethod, MaterialUsageCSVMethod } from "./MaterialUsageCSV";
import { AboveGISLocationClickMethods } from "../../Common/services/AboveGISMapLocationHelper";
import WorkOrderReport from "./DetailViews/ExecutionDetail/WorkOrderReport/WorkOrderReport";
import WorkOrderModal from "./DetailViews/ExecutionDetail/WorkOrderReport/WorkOrderModal";
import { WorkGangCSVMethod } from "./WorkGangCSV";
class MaintenanceDetailPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maintenanceDetails: [],
      selectedRowData: null,
      viewStatus: 1,
      summaryFormData: null,
      classToShow: "d-none",
      displayTitle: languageService("Show Inactive"),
      showHideExpands: false,
      ShowWorkOrderSummaryReport: false,
      warningDialog: false,
      deleteDocumentDialog: false,
      deleteDoc: { deleteDocumentName: "", index: null },
    };

    this.backup = new Map();

    this.updateLocalState = this.updateLocalState.bind(this);
    this.isDefectCodeButtonToShow = this.isDefectCodeButtonToShow.bind(this);
    this.handleStatusClick = this.handleStatusClick.bind(this);
    this.getUserDisplay = this.getUserDisplay.bind(this);
    this.handleGisMpMarkerLocationClick = this.handleGisMpMarkerLocationClick.bind(this);
    this.onExecutionSelect = this.onExecutionSelect.bind(this);
    this.onFormSelect = this.onFormSelect.bind(this);
    this.onSummaryFormSelect = this.onSummaryFormSelect.bind(this);
    this.onMaterialUsageCSV = this.onMaterialUsageCSV.bind(this);
    this.onMaterialUsageByExecutionCSV = this.onMaterialUsageByExecutionCSV.bind(this);
    this.setSummaryData = this.setSummaryData.bind(this);
    this.onWorkGangCSV = this.onWorkGangCSV.bind(this);
    this.handleDefectCode = this.handleDefectCode.bind(this);
    this.onDefectModelOpenMethod = this.onDefectModelOpenMethod.bind(this);
    this.openMRReportModel = null;
    this.openSummaryReportModel = null;
    this.openDefectCodesModel = null;
    this.HideWorkOrderReport = this.HideWorkOrderReport.bind(this);
    this.OpenWorkOrderReport = this.OpenWorkOrderReport.bind(this);
    this.openUserRedirectWarning = this.openUserRedirectWarning.bind(this);
    this.deleteDocumentHandle = this.deleteDocumentHandle.bind(this);
    this.deleteTheDocumentAfterConformation = this.deleteTheDocumentAfterConformation.bind(this);
    this.toggleDeletionModal = this.toggleDeletionModal.bind(this);
  }

  componentDidMount() {
    this.props.getMaintenance(this.props.match.params.id);

    if (this.props.assetTypes.length == 0) {
      this.props.getAssetType();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    onLineSelfLoad(prevProps, this.props, this.updateLocalState, this.state);
    onMaintenanceReceive(prevProps, this.props, this.updateLocalState, this.props.lineAsset, this.props.getAssetLinesWithSelf);
    onExecutionInspectionReceive(prevProps, this.props, this.updateLocalState, this.props.getAppMockupsTypes);
    onMaterialTypesReceive(prevProps, this.props, this.setSummaryData);
    const { maintenanceActionType } = this.props;
    if (maintenanceActionType != prevProps.maintenanceActionType && maintenanceActionType === "MAINTENANCE_UPDATE_SUCCESS") {
      this.props.getMaintenance(this.props.match.params.id);
    }
  }

  componentWillUnmount() { }

  updateLocalState(state) {
    this.setState({ ...state });
  }
  HideWorkOrderReport() {
    this.setState({
      ShowWorkOrderSummaryReport: false,
    });
  }
  OpenWorkOrderReport() {
    this.setState({
      ShowWorkOrderSummaryReport: true,
    });
  }

  openUserRedirectWarning() {
    this.setState({
      warningDialog: true,
    });
  }
  findAssetTypeDefectsByName = () => {
    let at = null;
    let dc = null;
    const { maintenance } = this.state;
    const { assetTypes } = this.props;

    if (maintenance && maintenance.asset && assetTypes) at = assetTypes.find((a) => a.assetType === maintenance.asset.assetType);

    if (at && at.defectCodes) {
      dc = at.defectCodes.details;
    }

    return dc;
  };
  isDefectCodeButtonToShow() {
    let toShow = false;

    if (
      this.state.maintenanceDefectCodesObj &&
      this.state.maintenanceDefectCodesObj.defectCodes &&
      this.state.maintenanceDefectCodesObj.defectCodes.length > 0
    ) {
      let isFound = this.state.maintenanceDefectCodesObj.defectCodes.find((dc) => dc !== "");

      if (isFound) toShow = true;
    }

    return toShow;
  }

  handleStatusClick(status) {
    if (status !== this.state.viewStatus) {
      this.setState({
        viewStatus: status,
      });
    }
  }
  getUserDisplay(user, exec) {
    if (!user) return null;
    let userName = "";
    let userEmail = "";
    let mExecution = this.props.journeyPlan;
    if (exec) {
      userName = mExecution.user.name;
      userEmail = mExecution.user.email;
    } else {
      userName = user.name;
      userEmail = user.email;
    }
    return (
      <div style={themeService(maintenaceDetailstyle.fieldText)}>
        <Gravatar style={{ borderRadius: "30px", marginRight: "5px" }} email={userEmail} size={20} /> {userName}
      </div>
    );
  }

  handleGisMpMarkerLocationClick(type, workOrder) {
    let selectedAsset = AboveGISLocationClickMethods.selectedAsset(type, workOrder);
    let line = null;
    if (this.props.lineAssets && workOrder && workOrder.lineId) {
      line = this.props.lineAssets.find((l) => {
        return l._id == workOrder.lineId;
      });
    }
    let enableDisplay = line ? true : false;
    this.setState({
      gisDisplay: enableDisplay,
      selectedAsset: selectedAsset,
      lineAsset: line,
      maintenance: workOrder,
    });
  }

  format2Digit(num) {
    return num && !isNaN(parseFloat(num)) ? parseFloat(num).toFixed(2) : "0.00";
  }
  onExecutionSelect(id) {
    let selected = this.state.maintenanceDetails.find((m) => m._id === id);
    this.setState({
      selectedRowData: selected,
    });
  }
  onFormSelect(formId) {
    this.setState({
      selectedForm: formId,
    });
    this.openMRReportModel && this.openMRReportModel();
  }

  onSummaryFormSelect(form) {
    this.setState({
      summaryFormData: form,
    });

    this.openSummaryReportModel && this.openSummaryReportModel();
  }

  setSummaryData() {
    // console.log(this.state.maintenanceDetails);
    let data = [...this.state.maintenanceDetails];
    let tempSummaryData = [];
    data &&
      data.length &&
      data.forEach((dataElement) => {
        dataElement.tasks &&
          dataElement.tasks.length &&
          dataElement.tasks.forEach((task) => {
            task.maintenance &&
              task.maintenance.length &&
              task.maintenance.forEach((maintenance) => {
                maintenance.appForms &&
                  maintenance.appForms.length &&
                  maintenance.appForms.forEach((appForm) => {
                    if (!appForm) {
                      return;
                    } else if (appForm) {
                      const existingSummary = tempSummaryData.find((summary) => summary.id === appForm.id);

                      if (existingSummary) {
                        if (existingSummary.id) {
                          existingSummary.data.push(dataElement);
                        }
                      } else if (appForm.id && appForm.name) {
                        tempSummaryData.push({
                          id: appForm.id,
                          name: appForm.name,
                          data: [dataElement],
                        });
                      }
                    }
                  });
              });
          });
      });

    this.setState({
      summaryData: [...tempSummaryData],
    });
  }

  onMaterialUsageCSV() {
    let allExecs = [...this.state.maintenanceDetails];
    MaterialUsageCSVMethod(allExecs, this.state.maintenance.mrNumber, this.props.materialTypes);
  }
  onMaterialUsageByExecutionCSV() {
    let allExecs = [...this.state.maintenanceDetails];
    ExtendedMaterialUsageCSVMethod(allExecs, this.state.maintenance.mrNumber, this.props.materialTypes);
  }

  onWorkGangCSV() {
    let allExecs = [...this.state.maintenanceDetails];
    WorkGangCSVMethod(allExecs, this.state.maintenance.mrNumber, this.props.materialTypes);
  }

  handleDefectCode() {
    this.setState({
      classToShow: this.state.classToShow == "d-none" ? "show" : "d-none",
      showHideExpands: !this.state.showHideExpands,
      displayTitle:
        this.state.displayTitle == languageService("Hide Inactive") ? languageService("Show Inactive") : languageService("Hide Inactive"),
    });
  }

  onDefectModelOpenMethod() {
    this.openDefectCodesModel && this.openDefectCodesModel();
  }
  deleteDocumentHandle(docName, index) {
    this.setState({ deleteDocumentDialog: true, deleteDoc: { deleteDocumentName: docName, index: index } });
  }
  deleteTheDocumentAfterConformation(bool) {
    // debugger;
    if (bool) {
      const { index } = this.state.deleteDoc;
      let maintenance = JSON.parse(JSON.stringify(this.state.maintenance));

      if (Array.isArray(maintenance.documents) && index !== null && index !== undefined) {
        maintenance.documents.splice(index, 1);
      }
      this.setState({ deleteDocumentDialog: false, deleteDoc: { deleteDocumentName: "", index: null } });

      this.props.updateMaintenance(maintenance, maintenance._id);
    } else this.setState({ deleteDocumentDialog: false, deleteDoc: { deleteDocumentName: "", index: null } });
  }
  toggleDeletionModal(bool) {
    // debugger;
    this.setState({ deleteDocumentDialog: false, deleteDoc: { deleteDocumentName: "", index: null } });
  }
  render() {
    const closedBy = JourneyPlanHelper.getMaintenanceClosedBy(this.state.maintenanceDetails);
    return (
      <Fragment>
        <div className="mainContent no-print">
          <ReportMrModel
            openReportModelMethod={(method) => (this.openMRReportModel = method)}
            selectedRowData={this.state.selectedRowData}
            formId={this.state.selectedForm}
            materialTypes={this.props.materialTypes}
          />

          <ReportMrModel
            openReportModelMethod={(method) => (this.openSummaryReportModel = method)}
            summaryFormData={this.state.summaryFormData}
            materialTypes={this.props.materialTypes}
          />

          <MaintenanceDetailHeaderView mainTitle={languageService("Work Order")} />

          <M_DetailContainer
            maintenanceDetails={this.state.maintenanceDetails}
            m1={this.state.maintenance ? this.state.maintenance : {}}
            selectedRowData={this.state.selectedRowData}
            closedBy={closedBy}
            showHideExpands={this.state.showHideExpands}
            summaryData={this.state.summaryData}
            viewStatus={this.state.viewStatus}
            assetTypes={this.props.assetTypes}
            gisDisplayProps={{
              gisDisplay: this.state.gisDisplay,
              lineAsset: this.state.lineAsset,
              selectedAsset: this.state.selectedAsset,
            }}
            defectCodeModelProps={{
              displayTitle: this.state.displayTitle,
              classToShow: this.state.classToShow,
              maintenanceDefectCodesObj: this.state.maintenanceDefectCodesObj,
            }}
            methods={{
              handleStatusClick: this.handleStatusClick,
              isDefectCodeButtonToShow: this.isDefectCodeButtonToShow,
              findAssetTypeDefectsByName: this.findAssetTypeDefectsByName,
              getUserDisplay: this.getUserDisplay,
              handleGisMpMarkerLocationClick: this.handleGisMpMarkerLocationClick,
              onExecutionSelect: this.onExecutionSelect,
              onFormSelect: this.onFormSelect,
              onSummaryFormSelect: this.onSummaryFormSelect,
              onMaterialUsageCSV: this.onMaterialUsageCSV,
              onMaterialUsageByExecutionCSV: this.onMaterialUsageByExecutionCSV,
              onWorkGangCSV: this.onWorkGangCSV,
              handleDefectCode: this.handleDefectCode,
              setDefectCodeModel: (method) => (this.openDefectCodesModel = method),
              onDefectModelOpenMethod: this.onDefectModelOpenMethod,
              openUserRedirectWarning: this.openUserRedirectWarning,
              OpenWorkOrderReport: this.OpenWorkOrderReport,
              deleteDocumentHandle: this.deleteDocumentHandle,

            }}
          />

          <ConfirmationDialog
            modal={this.state.warningDialog}
            toggle={() => this.setState(({ warningDialog }) => ({ warningDialog: !warningDialog }))}
            handleResponse={() => this.setState({ warningDialog: false })}
            hideConfirm={true}
            confirmationMessage={
              <div style={{ color: "red" }}>
                {languageService(
                  "You need to upload your profile signature to continue. Please download/install the mobile app and add your signature to proceed.",
                )}
                <div style={{ marginTop: "10px" }}>
                  <span style={{ fontWeight: "bold" }}>{languageService("Note")}:</span>
                  {languageService(
                    " If you have already added the profile signature in mobile app, please re-login to web app in order to proceed with the work order execution.",
                  )}{" "}
                </div>
              </div>
            }
            headerText={languageService("Signature Required")}
          />
          <ConfirmationDialog
            modal={this.state.deleteDocumentDialog}
            toggle={this.toggleDeletionModal}
            handleResponse={this.deleteTheDocumentAfterConformation}
            confirmationMessage={`${languageService("Are you sure you want to remove: ")} ${this.state.deleteDoc.deleteDocumentName}?`}
            headerText={languageService("Confirm Removal")}
          />
        </div>

        <WorkOrderModal
          open={this.state.ShowWorkOrderSummaryReport}
          m1={this.state.maintenance}
          selectedRowData={this.state.selectedRowData}
          maintenanceDetails={this.state.maintenanceDetails}
          handleBack={() => this.HideWorkOrderReport()}
          closedBy={closedBy}
        />
      </Fragment>
    );
  }
}
const getJourneyPlans = curdActions.getJourneyPlans;
const getMaintenance = curdActions.getMaintenance;
const updateMaintenance = curdActions.updateMaintenance;
const getAssetType = curdActions.getAssetType;
let actionOptions = {
  create: false,
  update: false,
  read: false,
  delete: false,
  others: {
    getMaintenance,
    getJourneyPlans,
    getAssetLinesWithSelf,
    getAssetType,
    getAppMockupsTypes,
    updateMaintenance,
  },
};
let reducersCustom = ["maintenanceReducer", "journeyPlanReducer", "assetHelperReducer", "assetTypeReducer", "diagnosticsReducer"];

let variableList = {
  maintenanceReducer: { maintenance: "" },
  journeyPlanReducer: { journeyPlans: [] },
  assetHelperReducer: { lineAssets: [] },
  assetTypeReducer: { assetTypes: [] },
  diagnosticsReducer: {
    materialTypes: [],
  },
};
const MaintenanceDetailContainer = CRUDFunction(
  MaintenanceDetailPage,
  "MaintenanceDetailPage",
  actionOptions,
  variableList,
  reducersCustom,
);

export default MaintenanceDetailContainer;



// WEBPACK FOOTER //
// ./src/components/Maintenance/MaintenanceDetailPage/MaintenanceDetailPage.jsx